module.exports = __webpack_public_path__ + "img/sq4m_04.0ffd5081.jpg";